import React, { useState, useRef } from 'react';
import TableMainContent from './table-main-content';
import TablePublicContent from './table-public-content';
import { BreadCrumb } from '../common/breadcrumb';
import { useParams } from 'react-router-dom';
import instance from '../../services/axios';
import { useNavigate } from 'react-router-dom';
import { useJWTAuth } from "../../services/JWTAuthProvider";
import AddNewPop from '../common/add-new-pop/index'
import UploadFile from './upload-file/index'
import CreateFolder from './create-folder';
import AddLink from './add-link';
import Rename from './rename';
import { userRole } from '../../constants/appConst';
import EditLink from './edit-link/index';
import api from '../../services/axios';
import Swal from "sweetalert2";
import { isGlobalAdmin,hasFolderRole } from "../../lib/permissionHelper";



export const Content = () => {
    const [selectedFolderItems, setSelectedFolderItems] = useState(null);
    const [breadcrumbItems, setBreadcrumbItems] = useState([]);
    const [modalUploadFile, setModalUploadFile] = useState({
        folderId: '', path: '', isOpen: false
    });
    const [modalCreateFolder, setModalCreateFolder] = useState({
        isOpen: false, folderId: null, isPublic: false
    });
    const [modelAddLink, setModelAddLink] = useState({
        isOpen: false, folderId: '', path: '', isPublic: false
    })
    const [modalRename, setModalRename] = useState({
        isOpen: false, id: null, name: null, type: null
    });
    const [modalEdit, setModalEdit] = useState({
        isOpen: false, id: null, name: null, linkname: null, type: null
    })
    const [lastModalParentID, setLastModalParentID] = useState(null);

    const [destinationPath, setDestinationPath] = useState('');
    const [publicFolderItems, setPublicFolderItems] = useState(null);
    const [tableMainRefresh, setTableMainRefresh] = useState(false);
    const [publicTableRefresh, setPubilcTableRefresh] = useState([]);
    const { user, refreshFolders } = useJWTAuth();


    const navigate = useNavigate();
    const { folderId } = useParams();
    const divRef = useRef(null);


    React.useEffect(() => {
        const getData = async () => {
            try {
                const { data } = await instance.get("Folders/ParentId?FolderIdentifier=" + folderId);
                if (data.result.isPublic) {
                    setTimeout(() =>
                        publicfolderClickCallBack(data.result.idPath.split('\\')[data.result.idPath.split('\\').length - 2].toLowerCase(), folderId)
                        , 1000);
                }
                else {
                    setSelectedFolderItems(data.result);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        setPublicFolders()
        if (folderId)
            getData();
        else {
            setSelectedFolderItems(null)
            if (user.folders && user.folders[0])
                navigate('/' + user.folders[0].folderIdentifier);
        }
        divRef.current?.scrollIntoView();
    }, [folderId]);

    React.useEffect(() => {
        if (selectedFolderItems?.path && selectedFolderItems?.idPath) {
            let items = [];
            let labels = selectedFolderItems.path.split('\\');
            let ids = selectedFolderItems.idPath.split('\\');
            
            labels.forEach((val, index) => {
                if (ids[index]) {
                    items.push({
                        label: val,
                        url: '/' + ids[index].toLowerCase()
                    });
                }
            });
            setBreadcrumbItems(items);
            setDestinationPath(selectedFolderItems.path);
        }
    }, [selectedFolderItems]);

    const setPublicFolders = async () => {
        try {
            const { data } = await instance.get("Folders/GetPublicFolders");
            setPubilcTableRefresh(Array(data.result.folderLists.length).fill(false))
            setPublicFolderItems(data.result.folderLists);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const publicfolderClickCallBack = async (prevId, id) => {
        try {
            const { data } = await instance.get("Folders/GetPublicFolders?FolderId=" + id);
            if (data.result.folderLists && data.result.folderLists[0]) {
                const index = publicFolderItems.findIndex(e => e.folderIdentifier === prevId);
                let items = publicFolderItems;
                items[index] = data.result.folderLists[0];
                setPublicFolderItems([...items])
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const setModalUploadFileProps = (id, destinationPath, isOpen, parentId) => {
        setModalUploadFile({
            folderId: id,
            path: destinationPath,
            isOpen: isOpen
        })
        setLastModalParentID(parentId)
    };

    const setModalCreateFolderProps = (isOpen, id, isPublic, parentId) => {
        setModalCreateFolder({
            isOpen, folderId: id, isPublic
        })
        setLastModalParentID(parentId)
    };

    const setModalCreateLinkProps = (isOpen, id, destinationPath, isPublic, parentId) => {
        setModelAddLink({
            isOpen, folderId: id, path: destinationPath, isPublic
        })
        setLastModalParentID(parentId)
    };

    const setModalRenameProps = (isOpen, id, name, type, parentId) => {
        setModalRename({
            isOpen, id, name, type
        })
        setLastModalParentID(parentId)
    };

    const setModalEditProps = (isOpen, id, name, path, type, parentId) => {
        setModalEdit({
            isOpen, id, name, path, type
        })
        setLastModalParentID(parentId)
    };

    const successCallback = () => {
        const id = lastModalParentID;
        if (id) {
            if (folderId === id) {
                setTableMainRefresh(!tableMainRefresh);
            }
            const publicIndex = publicFolderItems.findIndex(e => e.folderIdentifier === id)
            if (publicIndex > -1) {
                let val = publicTableRefresh
                val[publicIndex] = !val[publicIndex];
                setPubilcTableRefresh(val);
            }
        }
    };



    const DeleteBusinessUnit = async (id, isPublic) => {
        Swal.fire({
            text: isPublic === true ? 'Are you sure you want to delete the folders? You might permanently lose all files and subfolders?' :'Are you sure you want to delete the business unit? You might permanently lose all files and subfolders?',
            confirmButtonText: 'Delete',
            showDenyButton: true,
            icon: 'warning',
            denyButtonText: 'Cancel',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { data } = await api.delete("Folders?FolderGuid=" + id);
                    if (data.statusCode === 200) {
                        Swal.fire({
                            position: "center",
                            icon: 'info',
                            text: "Business Unit deleted successfully",
                            confirmButtonText: "Ok",
                            timer: 3000,
                            timerProgressBar: true
                        }).then(() => {
                            if (isPublic)
                                setPublicFolders();
                            else
                                refreshFolders((value) => {
                                    if (value.folders && value.folders[0])
                                        navigate('/' + value.folders[0].folderIdentifier);
                                    else {
                                        navigate('/');
                                    }
                                });
                        })
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        })
    }


    return (
        <>
            <div ref={divRef} className='right-content'>
                <h3 className='content-head'>Welcome to Resource Center</h3>
                {
                    selectedFolderItems && !selectedFolderItems.isPublic ?

                        <div className='mid-box-wrap'>

                            <div className="sub-nav">
                                <div className='sub-nav2'>

                                    <BreadCrumb items={breadcrumbItems}></BreadCrumb>

                                    {
                                        isGlobalAdmin(user) && breadcrumbItems.length === 1 ?
                                            <div onClick={() => DeleteBusinessUnit(folderId)}>
                                                <span><img className='delete-icon' src='/Assets/trash.png' alt='Folder Icon' /></span>
                                            </div> : null
                                    }

                                </div>
                                {isGlobalAdmin(user)  || hasFolderRole(user, folderId,selectedFolderItems?.idPath, userRole.BusinessUnitAdmin) ?
                                    (
                                        <AddNewPop title='Add New Item'>
                                            <div onClick={() => setModalUploadFileProps(folderId, destinationPath, true, folderId)}>
                                                <span><img src='/Assets/file-icon.svg' alt='File Icon' /></span>
                                                File
                                            </div>
                                            <div onClick={() => setModalCreateFolderProps(true, folderId, false, folderId)}>
                                                <span><img src='/Assets/folder2-icon.svg' alt='Folder Icon' /></span>
                                                Folder
                                            </div>
                                            {
                                                isGlobalAdmin(user) ?
                                                    <div onClick={() => setModalCreateFolderProps(true, null, false, folderId)}>
                                                        <span><img src='/Assets/folder2-icon.svg' alt='Folder Icon' /></span>
                                                        Business Unit
                                                    </div> : null
                                            }
                                            <div onClick={() => setModalCreateLinkProps(true, folderId, destinationPath, false, folderId)}>
                                                <span><img src='/Assets/link.svg' alt='Link Icon' /></span>
                                                Link
                                            </div>
                                        </AddNewPop>) : null
                                }
                            </div>
                            <TableMainContent renameCallBack={(id, name, type) => setModalRenameProps(true, id, name, type, folderId)}
                                editCallBack={(id, name, linkname, type) => setModalEditProps(true, id, name, linkname, type, folderId)}
                                refreshTriggred={tableMainRefresh} 
                                folderId={folderId} 
                                idPath={selectedFolderItems?.idPath} />
                        </div> : null
                }
                {
                    publicFolderItems && publicFolderItems.length > 0 ?
                        <div className='mid-box-wrap'>
                            <div className='row mt-1 g-2'>
                                {
                                    publicFolderItems.map((val, index) => (
                                        <div key={val.folderIdentifier || index} className='col-md-6'>
                                        <div className='mid-box-wrap'>
                                            <div className="sub-nav">
                                                <div className='sub-nav2'>
                                                    <BreadCrumb callBack={({ folderIdentifier, parenFolderIdentifier }) => publicfolderClickCallBack(folderIdentifier, parenFolderIdentifier)}
                                                        items={val.parentFolder ?
                                                            [{
                                                                label: val.parentFolder.name,
                                                                callBackData: {
                                                                    folderIdentifier: val.folderIdentifier,
                                                                    parenFolderIdentifier: val.parentFolder.folderIdentifier
                                                                }
                                                            }, { label: val.name }]
                                                            : [{ label: val.name }]} />
                                                    {
                                                        isGlobalAdmin(user) && val.parentFolder === null ?
                                                            <div onClick={() => DeleteBusinessUnit(val.folderIdentifier, true)}>
                                                                <span><img className='delete-icon' src='/Assets/trash.png' alt='Folder Icon' /></span>
                                                            </div> : null
                                                    }
                                                </div>
                                                {isGlobalAdmin(user) ?
                                                    <AddNewPop title='Add New Item'>
                                                        <div onClick={() => setModalUploadFileProps(val.folderIdentifier, val.name, true, val.folderIdentifier)}>
                                                            <span><img src='/Assets/file-icon.svg' alt='File Icon' /></span>
                                                            File
                                                        </div>
                                                        <div onClick={() => setModalCreateFolderProps(true, val.folderIdentifier, true, val.folderIdentifier)}>
                                                            <span><img src='/Assets/folder2-icon.svg' alt='Folder Icon' /></span>
                                                            Folder
                                                        </div>
                                                        <div onClick={() => setModalCreateLinkProps(true, val.folderIdentifier, val.name, true, val.folderIdentifier)}>
                                                            <span><img src='/Assets/link.svg' alt='Folder Icon' /></span>
                                                            Link
                                                        </div>
                                                    </AddNewPop> : null
                                                }
                                            </div>
                                            <TablePublicContent renameCallBack={(id, name, type) => setModalRenameProps(true, id, name, type, val.folderIdentifier)}
                                                editCallBack={(id, name, linkname, type) => setModalEditProps(true, id, name, linkname, type, val.folderIdentifier)}
                                                refreshTriggred={publicTableRefresh[index]} folderId={val.folderIdentifier}
                                                folderClickCallBack={(parentId, id) => publicfolderClickCallBack(parentId, id)} />
                                        </div>
                                    </div>))
                                }
                            </div>
                        </div>
                        : null}
            </div>
            <UploadFile path={modalUploadFile.path} folderId={modalUploadFile.folderId} isOpen={modalUploadFile.isOpen}
                closeCallback={() => setModalUploadFileProps(null, null, false)} successCallback={successCallback} />

            <CreateFolder folderId={modalCreateFolder.folderId} isPublic={modalCreateFolder.isPublic} isOpen={modalCreateFolder.isOpen}
                closeCallback={() => setModalCreateFolderProps(false)} successCallback={successCallback} />

            <AddLink path={modelAddLink.path} folderId={modelAddLink.folderId} isOpen={modelAddLink.isOpen} isPublic={modelAddLink.isPublic}
                closeCallback={() => setModalCreateLinkProps(false)} successCallback={successCallback} />

            <Rename id={modalRename.id} isOpen={modalRename.isOpen} name={modalRename.name} type={modalRename.type}
                closeCallback={() => setModalRenameProps(false)} successCallback={successCallback} />

            <EditLink id={modalEdit.id} isOpen={modalEdit.isOpen} name={modalEdit.name} type={modalEdit.type} linkname={modalEdit.path}
                closeCallback={() => setModalEditProps(false)} successCallback={successCallback} />
        </>
    )
}